<template>
  <span>
         <img src="/clientV2/static/gfx/filter2.svg" class="iconBtn transition"
              @click="filterToggle = true"
              id="toolbarFilterIcon"
              v-tippy="{ placement : 'top'}"
              :title="(options.title) ? options.title : 'סינון מידע'">

        <div class="filterMenu" v-menufocus:opt="{class: 'filterMenu', trigger: 'filterToggle', el: 'toolbarFilterIcon'}" v-if="filterToggle === true">
          <div class="checkbox" v-for="(item, i) in options.items" style="position:relative;">
            <label>
								<checkbox :trueVal="checked.includes(item.value)"></checkbox>
								<input type="checkbox" v-model="checked" :value="item.value" :id="`filter-${i}`" @click="checkedChanged()">
                {{item.label}}
							</label>
              <span v-if="options.subFilter">
              <div v-if="checked.includes(item.value)" class="subMenuContainer">
               <div class="selectAll" @click="selectAll(item)">
                 בחר/הסר הכל
                </div>
                <div class="line"></div>
                <div v-for="element in item.list" style="position:relative;">{{element.data}}
                    <label class="checkboxPosition">
								      <checkbox :trueVal='element.bool'></checkbox>
								        <input type="checkbox" v-model="element.bool" :value="element.bool" @click="sort(item, element)" >
							    </label>
                </div>
              </div>
            </div>
          </span>
            <div class="clearFilter" @click="clearFilter(options.items)">
              איפוס
            </div>

        </div>
  </span>
</template>

<script>
  export default {
    name: 'FilterElement',
    props: ['options'],
    data () {
      return {
        filterToggle: false,
        checked: [],
        selectAllBool: false
      }
    },
    created () {
      this.checked = this.options.default
    },
    methods: {
      emitEvent: function (data) {
        this.$emit('emit', data)
      },
      checkedChanged(){
        this.checked.shift()
      },
      sort(item, element){
        element.bool = !element.bool
        this.emitEvent({method: `sort_${item.value}`, data: item.list})
      },
      selectAll(item){
          for(let j=0; j< item.list.length; j++){
            item.list[j].bool = this.selectAllBool
          }
          this.selectAllBool = !this.selectAllBool

          this.emitEvent({method: 'selectAll', data: item})
      },
      clearFilter(items){
        for(let i=0; i< items.length; i++){
          for(let j=0; j< items[i].list.length; j++){
            items[i].list[j].bool = true
          }
        }
        this.emitEvent({method: 'resetFilter', data: items})
      }
    },
    watch: {
      checked: function () {
        this.emitEvent({method: 'filterChanged', data: this.checked})
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/style.less";

  ul {
    li {
      cursor: pointer;
    }
  }

  .subMenuContainer{
  border: @border;
  background: @white;
  position: absolute;
  left: 0;
  max-width: 500px;
  top: -2%;
  transform: translate(-100%, 0);
  width: 150%;
  padding: 5px 25px;
  cursor: pointer;
  }

  .checkboxPosition{
    position:absolute;
    right: -20px;
    bottom: 0px;
  }
  .clearFilter {
    background: #ff6500;
    text-align: center;
    padding: 6px 0;
    color: @white;
    margin-top: 8px;
    cursor: pointer;
    width: 80%;
    display: block;
    margin-right: auto;
    margin-left: auto;
    position: relative;
    bottom: 4px;
    }
  .selectAll {
    background: #ff6500;
    text-align: center;
    padding: 6px 0;
    color: @white;
    margin-top: 8px;
    cursor: pointer;
    width: 80%;
    display: block;
    margin-right: auto;
    margin-left: auto;
    position: relative;
    bottom: 4px;
    }
  .line{
    width: 100%;
    height: 1px;
    background: #ccc;
    position:absolute;
    left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/toolbar/FilterElement.vue